import { useCurrentEditor } from '@tiptap/react'
import BoldIcon from '../../../icons/TipTapIcons/BoldIcon'
import ItalicIcon from '../../../icons/TipTapIcons/ItalicIcon'
import StrikeIcon from '../../../icons/TipTapIcons/StrikeIcon'
import ListIcon from '../../../icons/TipTapIcons/ListIcon'
import OrderListIcon from '../../../icons/TipTapIcons/OrderListIcon'

const MenuBar = () => {
  const { editor } = useCurrentEditor()
  if (!editor) {
    return null
  }

  return (
    <div className="d-flex flex-column flex-lg-row border-bottom p-2 gap-4">
      <div className="d-flex justify-content-start align-items-center gap-1">
        <div
          onClick={() => editor.chain().toggleBold().run()}
          className={`${
            editor.isActive('bold') ? 'border border-bg-CTA-primary' : ''
          } cursor-pointer rounded`}
        >
          <BoldIcon isActive={editor.isActive('bold')} />
        </div>
        <div
          onClick={() => editor.chain().toggleItalic().run()}
          disabled={!editor.can().chain().toggleItalic().run()}
          className={`${
            editor.isActive('italic') ? 'border border-bg-CTA-primary' : ''
          } cursor-pointer rounded`}
        >
          <ItalicIcon isActive={editor.isActive('italic')} />
        </div>
        <div
          onClick={() => editor.chain().toggleStrike().run()}
          disabled={!editor.can().chain().toggleStrike().run()}
          className={`${
            editor.isActive('strike') ? 'border border-bg-CTA-primary' : ''
          } cursor-pointer rounded`}
        >
          <StrikeIcon isActive={editor.isActive('strike')} />
        </div>
      </div>
      <div className="d-flex justify-content-start align-items-center gap-1">
        <div
          onClick={() => editor.chain().toggleBulletList().run()}
          className={`${
            editor.isActive('bulletList') ? 'border border-bg-CTA-primary' : ''
          } cursor-pointer rounded`}
        >
          <ListIcon isActive={editor.isActive('bulletList')} />
        </div>
        <div
          onClick={() => editor.chain().toggleOrderedList().run()}
          className={`${
            editor.isActive('orderedList') ? 'border border-bg-CTA-primary' : ''
          } cursor-pointer rounded`}
        >
          <OrderListIcon isActive={editor.isActive('orderedList')} />
        </div>
      </div>
    </div>
  )
}

export default MenuBar
